var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Note = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "18", height: "17" }, props),
        React.createElement("path", { fill: color, d: "M15 0a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H7.599L4 16.469V13H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h12zm0 1H3a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h2v2.116L7.196 12H15a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm-4 7v1H3V8h8zm4-2v1H3V6h12zm0-2v1H3V4h12z" })));
};
Note.defaultProps = {
    color: '#333',
};
export default Note;
//# sourceMappingURL=Note.js.map